<p-card [style]="style">
  <ng-template #header>
    <header
      class="flex items-center justify-end p-[var(--p-card-body-padding)]">
      <p-button
        text
        rounded
        severity="danger"
        icon="pi pi-ban"
        aria-label="Delete Video Scene"
        (onClick)="onDeleteClick()" />
      @if (!scene.value.id) {
        <p-button
          text
          rounded
          pTooltip="Not saved yet"
          icon="pi pi-bolt"
          severity="info"
          disabled />
      }
    </header>
  </ng-template>
  <section class="mb-4">
    <p-inplace>
      <ng-template pTemplate="display">
        @if (scene.value.description) {
          <span>{{ scene.value.description }}</span>
        } @else {
          <span class="text-[var(--p-orange-500)]">
            Description is required, click to edit it
          </span>
        }
      </ng-template>
      <ng-template pTemplate="content" let-closeCallback="closeCallback">
        <div class="relative">
          <p-inputgroup>
            <p-inputgroup-addon>
              <p-button
                class="h-full"
                icon="pi pi-check"
                variant="text"
                aria-label="Apply description changes"
                (onClick)="closeCallback()" />
            </p-inputgroup-addon>
            <p-iftalabel>
              <textarea
                [id]="scene.controls.$key.value + '-description'"
                pTextarea
                fluid
                [minRows]="3"
                autosize
                [formControl]="scene.controls.description"
                placeholder="Start typing a description..."></textarea>
              <label [for]="scene.controls.$key.value + '-description'">
                Description
              </label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </ng-template>
    </p-inplace>
  </section>
  <section>
    @if (scene.controls.shots.controls.length) {
      <div
        class="grid grid-flow-row-dense grid-cols-3 gap-3"
        cdkDropList
        cdkDropListOrientation="mixed"
        (cdkDropListDropped)="onShotDrop($event)">
        @for (
          shot of scene.controls.shots.controls;
          track shot.controls.$key.value
        ) {
          <div cdkDrag [cdkDragData]="shot.value">
            <app-video-shot
              [session]="session"
              [idea]="idea"
              [shot]="shot"
              (shotAdd)="onShotAddClick(shot)"
              (shotClone)="onShotCloneClick(shot)"
              (shotDelete)="onShotDeleteClick(shot)"
              (shotReset)="onShotResetClick(shot)" />
          </div>
        }
      </div>
    } @else {
      <div class="flex items-center justify-center">
        <p-button
          rounded
          outlined
          icon="pi pi-plus"
          severity="info"
          label="Add a Video Shot"
          (onClick)="onShotAddClick()" />
      </div>
    }
  </section>
</p-card>
